import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SM } from "@/components/Mark";

export default function ComplianceFooter() {
  const { user } = useAuth();
  const loc = useLocation();
  const govContext = !!user?.is_gov || loc.pathname.startsWith("/embi-gov") || loc.pathname.startsWith("/gov");

  if (govContext) {
    return (
      <footer className="mt-16 border-t border-[#4F84C4]/25 bg-[#061025]">
        <div className="px-4 sm:px-6 py-6 max-w-screen-2xl mx-auto">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#9CC2EE]">
            EMBI<span className="align-super text-[10px]">℠</span>-Gov · Operational Intelligence
          </div>
          <p data-testid="compliance-disclaimer" className="mt-3 text-[12px] leading-relaxed text-zinc-400 max-w-3xl">
            Prepared from human-sourced public signals for the licensed client's internal use. Analytical
            intelligence describing observed public discourse — not legal, financial, or policy advice, and
            not a prediction of outcomes.
          </p>
          <div className="mt-4 pt-4 border-t border-zinc-800/70 flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-[11px] text-zinc-500">
            <Link data-testid="footer-terms" to="/terms" className="hover:text-[#9CC2EE] transition-colors">Terms &amp; Conditions</Link>
            <Link data-testid="footer-privacy" to="/privacy" className="hover:text-[#9CC2EE] transition-colors">Privacy Policy</Link>
            <Link data-testid="footer-ai-ethics" to="/ai-ethics" className="hover:text-[#9CC2EE] transition-colors">AI Ethics &amp; Safety</Link>
            <Link data-testid="footer-vcie" to="/vcie" className="hover:text-[#9CC2EE] transition-colors">For Institutions</Link>
            <button
              data-testid="footer-cookie-prefs"
              onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))}
              className="hover:text-[#9CC2EE] transition-colors"
            >
              Cookie Preferences
            </button>
            <span className="text-zinc-700">© {new Date().getFullYear()} GlobalInsight.ai</span>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="mt-16 border-t border-zinc-800 bg-[#061025]">
      <div className="px-4 sm:px-6 py-6 max-w-screen-2xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400">
            EMBI<span className="align-super text-[10px]">℠</span> AI Impact · The Kitchen-Table View of AI
          </div>
        </div>
        <p data-testid="compliance-disclaimer" className="mt-3 text-[12px] leading-relaxed text-zinc-500 max-w-3xl">
          Generated from human-expressed signals. EMBI<SM /> is a plain-language read on public sentiment and
          expectation about AI, and may be inaccurate, incomplete, or out of date. It's meant to help you understand
          what's changing — not to replace your own judgment. Nothing here is financial, investment, medical, legal, or
          business advice.
        </p>
        <div className="mt-4 pt-4 border-t border-zinc-800/70 flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-[11px] text-zinc-500">
          <Link data-testid="footer-faq" to="/faq" className="hover:text-signal transition-colors">FAQ</Link>
          <Link data-testid="footer-communities" to="/newsrooms" className="hover:text-signal transition-colors">Newsrooms &amp; Publishers</Link>
          <Link data-testid="footer-associations" to="/associations" className="hover:text-signal transition-colors">Associations</Link>
          <Link data-testid="footer-vcie" to="/vcie" className="hover:text-signal transition-colors">For institutions</Link>
          <Link data-testid="footer-quarterly" to="/quarterly" className="hover:text-signal transition-colors">Quarterly reports</Link>
          <Link data-testid="footer-license" to="/license" className="hover:text-signal transition-colors">Index licensing</Link>
          <Link data-testid="footer-terms" to="/terms" className="hover:text-signal transition-colors">Terms &amp; Conditions</Link>
          <Link data-testid="footer-privacy" to="/privacy" className="hover:text-signal transition-colors">Privacy Policy</Link>
          <Link data-testid="footer-ai-ethics" to="/ai-ethics" className="hover:text-signal transition-colors">AI Ethics &amp; Safety</Link>
          <Link data-testid="footer-do-not-sell" to="/privacy#ccpa" className="hover:text-signal transition-colors">Do Not Sell or Share My Info</Link>
          <button
            data-testid="footer-cookie-prefs"
            onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))}
            className="hover:text-signal transition-colors"
          >
            Cookie Preferences
          </button>
          <span className="text-zinc-700">© {new Date().getFullYear()} GlobalInsight.ai · "Rotate the Intelligence"<SM /></span>
        </div>
      </div>
    </footer>
  );
}
